import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Booking.html?raw';
import on from 'dojo/on';
import WizardView from '../../../moreCore/UI/Wizard/WizardView';
import "../../../moreCore/UI/Wizard/WizardView";
import TiBookingForm from '../../../WidgetCollection/TransportIntermodal/BookingForm';
import"../../../WidgetCollection/TransportIntermodal/BookingForm";
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import "../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox";
import "../../../moreCore/UI/Edit/Edit";
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import { TiEntities } from "../../TransportIntermodal/TiTypes";

class TiBookingWizard extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private wizardContainer: HTMLElement;
    private debugContainer: HTMLElement;
    private tgInfoContainer: HTMLElement;
    private txtOrderNo: HTMLElement;

    private navRow: HTMLElement;
    private nav1: HTMLElement;
    private nav2: HTMLElement;
    private nav3: HTMLElement;
    private nav4: HTMLElement;
    private nav5: HTMLElement;
    private nav6: HTMLElement;

    private nav1Summary: HTMLElement;
    private nav2Summary: HTMLElement;
    private nav3Summary: HTMLElement;
    private nav4Summary: HTMLElement;
    private nav5Summary: HTMLElement;
    private nav6Summary: HTMLElement;

    private nav1Container: HTMLElement;
    private nav2Container: HTMLElement;
    private nav3Container: HTMLElement;
    private nav4Container: HTMLElement;
    private nav5Container: HTMLElement;
    private nav6Container: HTMLElement;

    private sectionWizardFinished: HTMLElement;

    private btnReturnToList: HTMLButtonElement;
    private btnAnotherBooking: HTMLButtonElement;

    private bookingForm: MdsLax<InstanceType<typeof TiBookingForm>>;

    private wizard: MdsLax<InstanceType<typeof WizardView>>;

    private setupWizard(): void {
        let wizard = new WizardView();
        this.wizard = wizard;

        wizard.placeAt(this.wizardContainer, "first");

        on(wizard, "change", lang.hitch(this, this._onWizardEvent));
        on(wizard, "pageswitch", lang.hitch(this, this._onWizardEvent));

        this.bookingForm = new TiBookingForm;
        this.bookingForm.placeAt(this.debugContainer);

        wizard.setupNavigation(false, "none", "none");
        //wizard.setupNavigation(true, true, true);
        //wizard.setupFinishEvent( lang.hitch(this, this._on))

        let index = -1;
        index = wizard.addPage(this.bookingForm, this.bookingForm.sectionStep1, "changeStep1", "step1_Valid", "step1_Summary", "TERMINAL & DIVISION");

        index = wizard.addPage(this.bookingForm, this.bookingForm.sectionStep2, "changeStep2", "step2_Valid", "step2_Summary", "CHOOSE TRAILER");
        wizard.addPageRule(index, "switchToIfPreviousIsValid");

        index = wizard.addPage(this.bookingForm, this.bookingForm.sectionStep3, "changeStep3", "step3_Valid", "step3_Summary", "ROUTE & TRAIN");
        wizard.addPageRule(index, "switchToIfPreviousIsValid");

        index = wizard.addPage(this.bookingForm, this.bookingForm.sectionStep4, "changeStep4", "step4_Valid", "step4_Summary", "OFFLOADING");
        wizard.addPageRule(index, "switchToIfPreviousIsValid");

        index = wizard.addPage(this.bookingForm, this.bookingForm.sectionBookingConfirmation, "changeStep5", "step5_Valid", null, "YOUR BOOKING");
        wizard.addPageRule(index, "switchToIfPreviousAreValid");

        index = wizard.addPage(this.bookingForm, this.bookingForm.sectionDispo, "changeStep6", "step6_Valid", "step6_Summary", "DISPO"); //entladeliste
        wizard.addPageRule(index, "switchToIfPreviousIsValid");

        index = wizard.addPage(this.bookingForm, this.bookingForm.sectionBookingSummary, null, null, null, "SUMMARY");
        wizard.addPageRule(index, "switchToIfPreviousAreValid");



        // ausblenden: 
        //wizard.hidePage(0); // erste Seite mit Division + Terminal
        //wizard.hidePage(4); // Seite zum Abschicken der Buchung
        //wizard.hidePage(6); // Bestätigungsseite

        this.bookingForm.on("transportGoodChanged", lang.hitch(this, this._onChange_TransportGood));
        //this.switchToPage(0);


    }
    _onWizardEvent(data: Wizard.WizardPageEntry) {
        let summary = this.wizard.getPageSummary(data.index);
        //console.debug("_onWizardEvent", data, summary);

        let navTarget = null;
        let target: HTMLElement = null;

        let currentPage = this.wizard.getCurrentSelectedPageIndex();

        switch (data.index) {
            case 0:
                target = this.nav1Summary;
                navTarget = this.nav1;

                break;

            case 1:
                target = this.nav2Summary;
                navTarget = this.nav2;
                break;

            case 2:
                target = this.nav3Summary;
                navTarget = this.nav3;
                break;

            case 3:
                target = this.nav4Summary;
                navTarget = this.nav4;
                break;

            case 5: // entladeliste
                target = this.nav5Summary;
                navTarget = this.nav5;
                break;

            case 6:
                target = this.nav6Summary;
                navTarget = this.nav6;
                break;
        }

        if (navTarget) {
            this.UiModder.domClass.remove(navTarget, "hoverDark");
        }

        let validPages = this.wizard.getValidPages(true);
        //validPages.sort() // TODO

        let bValid = true;
        this.UiModder.domClass.toggle(this.nav1, "enabled", bValid && currentPage <= 4);

        bValid = bValid && validPages.indexOf(0) != -1;
        this.UiModder.domClass.toggle(this.nav2, "enabled", bValid && currentPage <= 4);

        bValid = bValid && validPages.indexOf(1) != -1;
        this.UiModder.domClass.toggle(this.nav3, "enabled", bValid && currentPage <= 4);

        bValid = bValid && validPages.indexOf(2) != -1;
        this.UiModder.domClass.toggle(this.nav4, "enabled", bValid && currentPage <= 4);

        bValid = bValid && validPages.indexOf(4) != -1;
        this.UiModder.domClass.toggle(this.nav5, "enabled", bValid);

        bValid = bValid && validPages.indexOf(5) != -1;
        this.UiModder.domClass.toggle(this.nav6, "enabled", bValid);

        this.UiModder.domClass.toggle(this.nav1, "hoverDark", currentPage != 0);
        this.UiModder.domClass.toggle(this.nav2, "hoverDark", currentPage != 1);
        this.UiModder.domClass.toggle(this.nav3, "hoverDark", currentPage != 2);
        this.UiModder.domClass.toggle(this.nav4, "hoverDark", currentPage != 3);
        // Achtung: page index 4 (Buchung abschicken) hat kein nav. daher sind nav 1 - 4 die pages 0 - 3, page 5 ist in wirklichkeit schon index 5
        this.UiModder.domClass.toggle(this.nav5, "hoverDark", currentPage != 5);
        this.UiModder.domClass.toggle(this.nav6, "hoverDark", currentPage != 6);

        this.UiModder.domClass.toggle(this.nav1, "selected", currentPage == 0);
        this.UiModder.domClass.toggle(this.nav2, "selected", currentPage == 1);
        this.UiModder.domClass.toggle(this.nav3, "selected", currentPage == 2);
        this.UiModder.domClass.toggle(this.nav4, "selected", currentPage == 3);
        this.UiModder.domClass.toggle(this.nav5, "selected", currentPage == 5);
        this.UiModder.domClass.toggle(this.nav6, "selected", currentPage == 6);

        if (target) {
            this.UiModder.domAttr.set(target, "innerHTML", summary);
        }
        if (validPages.indexOf(0) != -1) {
            this.hideNode(this.navRow, false);
        } else {
            this.switchToPage(0);
        }

        if (validPages.indexOf(6) != -1) {
            this.UiModder.domClass.add(this.navRow, "w3-hide");
        }

        this.UiModder.domClass.toggle(this.sectionWizardFinished, "w3-hide", this.wizard.getCurrentSelectedPageIndex() != 6);


        if (validPages.length == 6) {
            this._data = this.bookingForm.getData();
            
        } else {
            this._data = null;
        }

    }

    private _onChange_TransportGood(entity: TiEntities.TransportGoodEntity) {
        this.hideNode(this.tgInfoContainer, !entity);
        this.txtOrderNo.innerHTML = entity?.order_number;
    }

    private _data: any = null;


    private selectedPage: number = -1;

    
    private switchToPage(target: number) {
        if (this.wizard.getCurrentSelectedPageIndex() == target) {
            target = 6; // zur Buchungszusammenfassung zurück
        }

        if (this.wizard.getPageSelectable(target)) {
            this.wizard.switchToPage(target);
        }
    }


    private _onClick_Nav1(evt: MouseEvent) {
        this.switchToPage(0);
    }

    private _onClick_Nav2(evt: MouseEvent) {
        this.switchToPage(1);
    }
    private _onClick_Nav3(evt: MouseEvent) {
        this.switchToPage(2);
    }
    private _onClick_Nav4(evt: MouseEvent) {
        this.switchToPage(3);
    }

    private _onClick_Nav5(evt: MouseEvent) {
        this.switchToPage(5);
    }
    private _onClick_Nav6(evt: MouseEvent) {
        this.switchToPage(6);
    }

    private _onClick_AnotherBooking(evt: MouseEvent) {
        location.reload();
    }

    private _onClick_ReturnToList(evt: MouseEvent) {
        location.href = window.appRoot + "TransportIntermodal/List";

    }

    private _onClick_OpenUnloadingList(evt: MouseEvent) {

        let data = this.bookingForm.getData();

        let filterDate = data.dateEnd;

        let url = window.appRoot + `TransportIntermodal/UnloadingList?division=${data.divisionID}&terminal=${data.terminalID}&filterDate=${filterDate}&booking=${data.ID}`;
        //let url = window.appRoot + `TransportIntermodal/UnloadingList?division=00000109:00019443&terminal=00000109:0001944a&filterDate=2024-06-01&booking=0000015e:0000154d`;
        let popupWindow = null;
        let windowSize = 'width=1200,height=900,top=336';

        if (popupWindow === null || popupWindow.closed) {
            popupWindow = window.open(url, 'Entladeliste', windowSize);
        } else {
            popupWindow.focus();
        }

    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setupWizard();
    }
}

export default mdsWidget(TiBookingWizard);